import React from 'react';

function DriverHeader({ driver, onLogout }) {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="driver-info">
          <div className="driver-avatar">{driver?.user_name?.charAt(0) || 'D'}</div>
          <div className="driver-details">
            <h2>Hola, {driver?.user_name?.split(' ')[0] || 'Repartidor'}</h2>
            <p className="driver-phone">{driver?.phone}</p>
          </div>
        </div>
        <button onClick={onLogout} className="logout-btn">Salir</button>
      </div>
    </header>
  );
}

export default DriverHeader;
